"use strict";
exports.__esModule = true;
exports.ParserNodeList = void 0;
var ParserNode_1 = require("./ParserNode");
var ParserNodeList = /** @class */ (function () {
    function ParserNodeList(page, nodes) {
        this.nodes = nodes || [];
        this.page = page;
    }
    ParserNodeList.prototype.First = function () {
        var _a, _b;
        return new ParserNode_1.ParserNode(this.page, (_b = (_a = this.nodes) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.element);
    };
    ParserNodeList.prototype.Length = function () {
        return this.nodes.length || 0;
    };
    ParserNodeList.prototype.Last = function () {
        var _a;
        return new ParserNode_1.ParserNode(this.page, (_a = this.nodes) === null || _a === void 0 ? void 0 : _a[this.nodes.length - 1].element);
    };
    return ParserNodeList;
}());
exports.ParserNodeList = ParserNodeList;
//# sourceMappingURL=ParserNodeList.js.map